<!--------- Activación Línea Pack ----------->
<!------------------------------------------->
<div class="container content" [formGroup]="thirdFormGroup">

    <app-user-data-form id="userDataForm" #userDataForm [listener]="this" [showBankingData]="!(migrationData && !migrationData.migrationshowBanking)"></app-user-data-form>

    <!-- Continuar proceso -->
    <div align="center">
        <br>
        <a class="btn btn-black-outline btn-block mb-1" (click)="validar($event)" role="button">
            Continuar
            <img src="./assets/img/arrow-right.svg" class="img-fluid ico-title" width="15">
        </a>
        <a class="btn btn-grey-outline2 btn-block mb-5" (click)="previo()" role="button">Volver</a>
        <br><br>
    </div>

</div>



